/**
 * Account contact-property definitions (`/contact-properties`).
 * List queries use appendListParams / toQuerySuffix.
 */
import Api from "@/api/Api";
import { appendListParams, toQuerySuffix } from "@/api/buildQueryString";

export default {
  getContactProperties(page, pageSize, sortBy, sortDesc, query) {
    var params = {};
    if (query) params['query'] = query;
    appendListParams(params, page, pageSize, sortBy, sortDesc);
    params = toQuerySuffix(params);
    return Api().get('/contact-properties' + params);
  },

  getAccountContactProperties(accountId, page, pageSize) {
    var params = {};
    if (accountId) params['account_id'] = accountId;
    appendListParams(params, page, pageSize);
    params = toQuerySuffix(params);
    return Api().get('/contact-properties' + params);
  },

  addContactProperty(data) {
    return Api().post('/contact-properties', data);
  },

  getContactProperty(contactPropertyId) {
    return Api().get('/contact-properties/' + contactPropertyId);
  },

  updateContactProperty(contactPropertyId, data) {
    return Api().patch('/contact-properties/' + contactPropertyId, data);
  },

  removeContactProperty(contactPropertyId) {
    return Api().delete('/contact-properties/' + contactPropertyId);
  },
};
